<template>
  <div class="checkout__price">
    <div class="checkout__price-header">
      <div class="checkout__price-title">Стоимость аренды</div>
      <div class="checkout__price-sale" v-if="car.discount_percent">Скидка {{car.discount_percent}}%</div>
    </div>
    <div class="checkout__price-rows">
      <div class="checkout__price-row">
        <div class="checkout__price-row_title">За сутки</div>
        <div class="checkout__price-row_value"><span v-if="car.rate_per_day_old">{{formatPrice(car.rate_per_day_old)}}</span> {{formatPrice(car.rate_per_day)}} <i class="rouble-sign">₽</i></div>
      </div>
      <div class="checkout__price-row">
        <div class="checkout__price-row_title">За весь период ({{car.rent_period_days}} сут.)</div>
        <div class="checkout__price-row_value"><span v-if="car.rate_subtotal_old">{{formatPrice(car.rate_subtotal_old)}}</span> {{formatPrice(car.rate_subtotal)}} <i class="rouble-sign">₽</i></div>
      </div>
      <div class="checkout__price-row" v-if="car.extras.out_working_hours_fee > 0">
        <div class="checkout__price-row_title">Обслуживание в нерабочее время</div>
        <div class="checkout__price-row_value">{{formatPrice(car.extras.out_working_hours_fee)}} <i class="rouble-sign">₽</i></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Price',
    props: ['car'],
    methods: {
      formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
    }
}
</script>
